import * as React from 'react';

const Head = ({ headTitle, children, customStyle, }: {headTitle: string, children?: any, customStyle?: any}) => {
  return (
    <div className="head__cont" style={customStyle}>
      <h2 className="head__title">{headTitle}</h2>
      <div className="head__controls">
        {children}
      </div>
    </div>
  );
};

export default Head;
